import { Route } from '../Routes';
import Promotions from '../../containers_v2/promotions/Promotions';
import { Translate } from 'react-localize-redux';
import * as React from 'react';
import { BadgePercent } from 'lucide-react';
import { PrimaryColor } from '../../styles/global/css/Utils';

const PromotionsRoutes = (): Route[] => [
	{
		component: Promotions,
		path: '/promotions',
		menu: true,
		logoImg: <BadgePercent size='16' />,
		hoverImg: <BadgePercent color={PrimaryColor} size='16' />,
		activeImg: <BadgePercent color={PrimaryColor} size='16' />,
		name: <Translate id="campagnes" />,
		permission: ['ViewCampaign'],
	}
];

export default PromotionsRoutes;
